export default (password) => {
  // probably already handled by the required flag
  if (typeof password === 'undefined' || password === null) {
    return true;
  }

  // Minimum of 1 Uppercase or lowercase alphabet
  if (/[A-Za-z]/.test(password) === false) {
    return false;
  }

  // Minimum of 1 special character: ! @ # $ % ^ & *( ) - _ = + [ { ] } \ | ; : < , > . / ?
  if (/[ /\-:;<>,.!@#$%^&*?()_+={}[\]|\\]/.test(password) === false) {
    return false;
  }

  // Minimum of 1 Number
  if (/\d/.test(password) === false) {
    return false;
  }

  // Minimum of 8 Characters
  // separately targeting input length

  return true;
};
